import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import { useChatContext } from 'features/message-center/providers';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { SearchInput, SearchResult } from './components';
import { useSearchContacts } from './SearchContactsDrawer.hooks';
import { SearchResultContainer } from './SearchContactsDrawer.styled';

export const SearchContactsDrawer = ({
  initialPhoneNumber,
  isDrawerOpen,
  onNewConversation,
  onClose
}) => {
  const { openDrawer } = useChatContext();
  const { contact, handleSelectValue, uiState } = useSearchContacts({ initialPhoneNumber });

  const handleNewConversation = ({ newMessage }) => {
    const recipient = {
      countryCode: newMessage?.countryCode ?? '+1',
      entityId: newMessage?.entityId,
      entityType: newMessage?.entityType,
      name: newMessage?.fullName,
      phone: newMessage?.phone
    };

    const onSendNewMessage = () => {
      onNewConversation({ externalNumber: newMessage?.externalNumber });
    };

    openDrawer({
      recipient,
      onSendNewMessage
    });

    onClose();
  };

  const isFormReady = !initialPhoneNumber || (!uiState.isSearching && uiState.hasFinished);

  return (
    <FPDrawer
      CardHeaderProps={{ title: strings.messageCenter.newMessage }}
      FPDrawerProps={{ open: isDrawerOpen }}
      hideFooter
      onClose={onClose}
    >
      <When condition={uiState.isSearching}>
        <LinearProgress />
      </When>
      <When condition={isFormReady}>
        <Typography>{strings.messageCenter.newConversation.searchContact}</Typography>
        <SearchInput onSelectValue={handleSelectValue} contact={contact} />
        <When condition={contact}>
          <SearchResultContainer>
            <SearchResult contact={contact} onNewConversation={handleNewConversation} />
          </SearchResultContainer>
        </When>
      </When>
    </FPDrawer>
  );
};
